// extracted by mini-css-extract-plugin
module.exports = {"summary":"summary--9jJQM","children":"children--3edkr","blackFriday2019":"blackFriday2019--3d03P"};